// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__Qihsu","dragIcon":"Choice_dragIcon__1vmEX","left":"Choice_left__3Eg3E","input":"Choice_input__30dkY"};